import styles from "./styles.module.scss";
import VerificationWidget from "./widget";

export {styles};
export default VerificationWidget;